import { useQuery } from '@tanstack/react-query'
import { content } from '../../../v2/content'
import { globalQueryKeys } from '../../queryKeys'

export function useReadContentById(contentId: string, enabled = true) {
  return useQuery({
    queryKey: globalQueryKeys.contentById(contentId),
    queryFn: () =>
      content.readSingle({ path: { content_id: contentId }, query: {} }),
    enabled,
    select: (response) => {
      return {
        id: response.data.id,
        type: response.data.type,
        name: response.data.attributes.name,
        richTextDocumentId:
          response.data.relationships.rich_text_document.data?.id,
      }
    },
  })
}
